import {
  RefractoryChemicalDataType,
  type RefractoryPhysicalDataFilter
} from '@domain/refractory-product-catalog'

export interface DraftRange {
  min: string
  max: string
}

export interface AdvancedFiltersFormValues {
  chemicalData: DraftRange[]
  csRatio: DraftRange
  measurementSystem: RefractoryPhysicalDataFilter['measurementSystem']
  physicalData: Record<PhysicalFilterField, DraftRange>
}

export type PhysicalFilterField = Exclude<keyof RefractoryPhysicalDataFilter, 'measurementSystem'>

interface PhysicalFilterFieldConfig {
  name: PhysicalFilterField
  bounds: readonly ('min' | 'max')[]
}

export const physicalFilterFields = [
  {name: 'bulkDensity', bounds: ['max']},
  {name: 'porosity', bounds: ['min']},
  {name: 'coldCrushingStrength', bounds: ['max']},
  {name: 'abrasionResistance', bounds: ['min', 'max']},
  {name: 'shelfLife', bounds: ['min']}
] as const satisfies readonly PhysicalFilterFieldConfig[]

export const compounds = [
  RefractoryChemicalDataType.Al2O3,
  RefractoryChemicalDataType.SiO2,
  RefractoryChemicalDataType.CaO,
  RefractoryChemicalDataType.MgO,
  RefractoryChemicalDataType.Fe2O3,
  RefractoryChemicalDataType.Mn2O3,
  RefractoryChemicalDataType.P2O5,
  RefractoryChemicalDataType.SiC,
  RefractoryChemicalDataType.TiO2,
  RefractoryChemicalDataType.ZrO2
]
